import * as React from 'react'
import { useTemplateSelection } from './useTemplate'

// 🎯 NO PROPS! All data comes from template context
const TemplateSelector = () => {
	const { templates, selectedTemplateId, selectTemplate } = useTemplateSelection()

	const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const value = event.target.value
		if (value) {
			selectTemplate(value)
		}
	}

	return (
		<div className="template-selector-container">
			<label htmlFor="template-selector" className="template-selector-label">
				Template
			</label>
			<select
				id="template-selector"
				value={selectedTemplateId ?? ''}
				onChange={handleSelectChange}
				className="template-selector-dropdown"
			>
				<option value="">Select a template...</option>
				{templates.map((template) => (
					<option key={template.id} value={template.id}>
						{template.name}
					</option>
				))}
			</select>
		</div>
	)
}

export default TemplateSelector
